/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');
      this.arrow.setAttribute('aria-expanded', 'true');

    } else {
      submenu.classList.remove('active');
      this.arrow.setAttribute('aria-expanded', 'false');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.footer .thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    this.buttons = Array.from(document.querySelectorAll('.footer .thb-widget-title.collapsible'))
      .filter((button) => (
        button.dataset.footerAccordionReady !== 'true'
        && button.nextElementSibling?.classList.contains('thb-widget-menu')
      ));
    if (!this.buttons.length) return;

    this.mobileQuery = window.matchMedia('(max-width: 767px)');

    this.buttons.forEach((button) => {
      button.dataset.footerAccordionReady = 'true';
      button.addEventListener('click', () => this.toggle(button));
    });

    this.mobileQuery.addEventListener('change', () => this.syncViewportState());
    window.addEventListener('resize', () => this.refreshOpenMenuHeight());
    this.syncViewportState();
  }

  getMenu(button) {
    return button.nextElementSibling;
  }

  getOpenHeight(menu) {
    const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
    const currentPadding = parseFloat(window.getComputedStyle(menu).paddingBottom) || 0;
    const targetPadding = 1.25 * rootFontSize;
    return `${menu.scrollHeight + Math.max(0, targetPadding - currentPadding)}px`;
  }

  setExpanded(button, expanded) {
    const menu = this.getMenu(button);
    if (!menu) return;

    if (expanded) {
      menu.style.setProperty('--footer-menu-height', this.getOpenHeight(menu));
    }

    button.classList.toggle('active', expanded);
    button.setAttribute('aria-expanded', String(expanded));
    menu.setAttribute('aria-hidden', String(!expanded));
    menu.inert = !expanded;

    if (!expanded) {
      button.blur();
    }
  }

  closeOtherMenus(activeButton) {
    this.buttons.forEach((button) => {
      if (button !== activeButton && button.classList.contains('active')) {
        this.setExpanded(button, false);
      }
    });
  }

  toggle(button) {
    if (!this.mobileQuery.matches) return;

    const willOpen = !button.classList.contains('active');
    if (willOpen) {
      this.closeOtherMenus(button);
    }
    this.setExpanded(button, willOpen);
  }

  refreshOpenMenuHeight() {
    if (!this.mobileQuery.matches) return;

    this.buttons.forEach((button) => {
      if (!button.classList.contains('active')) return;
      const menu = this.getMenu(button);
      menu.style.setProperty('--footer-menu-height', this.getOpenHeight(menu));
    });
  }

  syncViewportState() {
    this.buttons.forEach((button) => {
      const menu = this.getMenu(button);

      if (this.mobileQuery.matches) {
        this.setExpanded(button, false);
      } else {
        button.classList.remove('active');
        button.setAttribute('aria-expanded', 'true');
        menu.setAttribute('aria-hidden', 'false');
        menu.inert = false;
      }
    });
  }
}

const initializeFooterMenuToggle = () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeFooterMenuToggle, { once: true });
} else {
  initializeFooterMenuToggle();
}

document.addEventListener('shopify:section:load', initializeFooterMenuToggle);
